var moment = require("moment");
var RepositoryAPI = require("../../../../common/api/repository");

module.exports = function($scope, item) {
  $scope.item = item;
  var watchImage = function() {
    $scope.$watch("item.image", function(newEventImage) {
      if (newEventImage) {
        var fileName = $scope.item.image.fileName;
        var item = $scope.item;
        var url = encodeURI(window.conf.doc_repos_url + "get/" + encodeURIComponent(item.image.id) + "/" + fileName);
        item.url = url;
      }
    });
  };
  watchImage();

  var stripUnusedParameters = function(item) {
    delete item.image;
    return item;
  };

  $scope.submit = function() {
    $scope.closeThisDialog({ action: "submit", item: (stripUnusedParameters($scope.item)) });
  };

  $scope.cancel = function() {
    $scope.closeThisDialog({ action: "cancel" });
  };
};
